import {Injectable} from '@angular/core';

declare let toaster: any;
declare let $: any;

@Injectable()
export class TemplateHelper {
    public setLoading(enable) {
        enable ? $('#loader_data').removeClass('hide_elements') : $('#loader_data').addClass('hide_elements');
    }

    /**
     * Themes [primary,info,warning,danger,success]
     */
    public showToast(message, theme = 'success', title = '') {
        toaster(message, theme, title);
    }

    public showModal(id) {
        $('#' + id).modal('show');
    }

    public closeModal(id) {
        $('#' + id).modal('hide');
    }

    public Pagination(currentPage, totalPages) {
        const links = [];
        if (totalPages >= 1 && currentPage <= totalPages) {
            links.push(1);

            let i = Math.max(2, currentPage - 5);
            if (i > 2) {
                links.push(' ... ');
            }

            for (; i < Math.min(currentPage + 6, totalPages); i++) {
                links.push(i);
            }

            if (i !== totalPages) {
                links.push(' ... ');
            }

            links.push(totalPages);

            return links;
        }
    }

    public ObjectToQueryParams(params) {
        let keys = '';
        Object.keys(params).forEach((v, k) => {
            if (params[v]) {
                keys += v + '=' + params[v] + '&';
            }
        });
        return keys.slice(0, -1);
    }

    public ObjectToQueryParamsMap(params) {
        return Object.keys(params).map(key => key + '=' + params[key]).join('&');
    }

    public ObjectToQueryParamsJquery(params) {
        return $.param(params);
    }

    public UpdateUrlState(url: string) {
        return history.pushState(null, null, url);
    }

    public UrlObject(url: string) {
        return new URL(url);
    }

    public WindowLocation() {
        return window.location;
    }

    public CurrentLocation() {
        const windowObj = this.WindowLocation();
        return windowObj.origin + windowObj.pathname;
    }

    public jQFormSerializeArrToFormData(formSerializeArr, formData: FormData) {
        jQuery.map(formSerializeArr, (n, i) => {
            formData.append(n.name, n.value);
        });

        return formData;
    }

    public jQFormSerializeArrToJson(formSerializeArr) {
        const formData = {};
        $.map(formSerializeArr, (n, i) => {
            formData[n.name] = n.value;
        });

        return formData;
    }

    public jQObjectToFormData(item) {
        const formData = new FormData();
        Object.keys(item).forEach(key => formData.append(key, item[key]));
        return formData;
    }
}
